import { useQuery } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';

export interface HtmlComponentDto {
  id: string;
  name: string;
  html: string;
  version: number;
  scope: string;
  updatedAt: string;
}

export const GET_HTML_COMPONENTS_QUERY_KEY = 'get-html-components';

export const useGetHtmlComponentsQuery = () => {
  const { getToken } = useAuth();

  return useQuery({
    queryKey: [GET_HTML_COMPONENTS_QUERY_KEY],
    queryFn: async () => {
      const token = await getToken();
      const url = `${import.meta.env.VITE_API_URL}/html-components`;
      return sendJSONRequest({ url, method: METHOD.GET, token: token ?? undefined }) as Promise<HtmlComponentDto[]>;
    },
  });
};
